import { AlphaLBoxOutlineIcon } from './AlphaLBoxOutlineIcon';

/**
 * author: Contributors
 * id C0044FE0-893A-4429-A57F-9C58DFBE36CC
 * name alpha-l-box-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-l-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterLBoxOutlineIcon = AlphaLBoxOutlineIcon;
export default LetterLBoxOutlineIcon